export default __webpack_public_path__ + "static/media/during-valuation.e10fa605.svg";